export default "__VITE_ASSET__CAmffUe4__"